export default "__VITE_ASSET__A3am03sZ__"